import React, { useState, MouseEvent } from "react";
import { clientsProps } from "../../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import { UPDATE_CLIENT_NAME_END_POINT } from "../../../../../config/config";
import { AxiosError } from "axios";

const UpdateClient : React.FC<clientsProps> = ({id, client_name}) => {

    const [clientName, setClientName] = useState<string>(client_name);
    const [updateStatus, setUpdateStatus] = useState({
        updated : false,
        status : ''
    });
    const [loading, setLoading] = useState<boolean>(false);

    function UpdateClient (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(clientName === '') return setUpdateStatus({
            ...updateStatus,
            status : 'Please insert client name.'
        })
        setLoading(true);

        setTimeout(async()=>{
            try{
                await api.put(UPDATE_CLIENT_NAME_END_POINT+id, {client_name : clientName}, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setUpdateStatus({
                    ...updateStatus,
                    updated : true,
                    status : 'Client name updated!'
                })
                setClientName('');
                setLoading(false)
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setUpdateStatus({
                        ...updateStatus,
                        updated : false,
                        status : 'Unauthorized access!'
                    })
                }else{
                    setUpdateStatus({
                        ...updateStatus,
                        updated : false,
                        status : 'An error occured!'
                    })
                }
                setLoading(false)
            }
        },500);
    }

    return (
        <div>
            <div>
                Update Client Name
            </div>
            <div>
                <form>
                    <div className={updateStatus.updated ? 'text-green-600' : 'text-red-500'}>
                        {updateStatus.status}
                    </div>
                    <div className="input-container flex flex-col">
                        <label htmlFor="#client">Client Name:</label>
                        <input type="text" name="client_name" id="client" value={clientName} onChange={(e) => setClientName(e.target.value)} className="text-box" />
                    </div>
                    <div className="input-container">
                        {loading ? (
                            <button type="button" disabled className='button button-disabled'>
                                <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                            </button>
                        ) : (
                            <button type="button" onClick={UpdateClient} className="button button-vcc-primary text-md">
                                Update
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default UpdateClient;